import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import './index.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#365A49',
      light: '#708F7D',
      dark: '#254135',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#477A96',
      light: '#83A4B7',
      dark: '#305C73',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F6F8F7',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#26342D',
      secondary: '#66746D',
    },
    error: {
      main: '#B86B6B',
    },
    warning: {
      main: '#C49A6C',
    },
    info: {
      main: '#5A7D9A',
    },
    success: {
      main: '#6B8E7B',
    },
  },
  typography: {
    allVariants: { letterSpacing: 0 },
    fontFamily: '"Inter", "Noto Sans SC", "PingFang SC", "Microsoft YaHei", system-ui, sans-serif',
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
    button: { fontWeight: 500, textTransform: 'none' as const },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
  },
});

const routerBase = import.meta.env.BASE_URL.replace(/\/$/, '') || '/';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={routerBase}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
